
import Vue from "vue";
import axios from "axios";
import HomeModuleHeader from "@/components/HomeModuleHeader.vue";

export default Vue.extend({
  components: { HomeModuleHeader },
  data: () => ({
    news: [] as any,
    page: 1,
    numInOnePage: 10,
    newsHeaderProp: {
      title: "新闻公告",
      button: "更多",
      path: "/article/news",
    },
  }),
  mounted() {
    this.getNewsList();
  },
  methods: {
    formatDate(d: string) {
      try { return new Date(d).toISOString().split("T")[0]; }
      catch { return ""; }
    },
    getNewsList() {
      axios
        .post(Vue.prototype.apiUrl("get-item-list"), {
          collection: "article",
          need: {
            $or: [
              { type: "news" },
              { type: "notice" },
              { type: "recommend" },
            ],
          },
          page: this.page,
          numInOnePage: this.numInOnePage,
        })
        .then((response) => {
          this.news = response.data;
        });
    },
    gotoNews(id: string, link: string) {
      if (link != "") {
        window.location.href = link;
      } else {
        this.$router.push({ path: `/article/news/${id}` });
      }
    },
  },
});
